module.exports = __webpack_public_path__ + "static/media/orange-back.cc1698bb.png";